import { render } from "./friendly.vue?vue&type=template&id=50162a57"
import script from "./friendly.vue?vue&type=script&lang=js"
export * from "./friendly.vue?vue&type=script&lang=js"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__